import { palette } from "./palette"

const text = {
  default: `var(--future-text-default, ${palette.silicon95})`,
  secondary: `var(--future-text-secondary, ${palette.silicon60})`,
  highlight: `var(--future-text-highlight, ${palette.lilac65})`,
  info: `var(--future-text-info, ${palette.magnetic70})`,
  success: `var(--future-text-success, ${palette.mint80})`,
  warning: `var(--future-text-warning, ${palette.turmeric90})`,
  error: `var(--future-text-error, ${palette.salmon80})`,
  inverted: `var(--future-text-inverted, ${palette.white})`,
  disabled: `var(--future-text-disabled, ${palette.silicon40})`,
  placeholder: `var(--future-text-placeholder, ${palette.silicon45})`,
} as const

const background = {
  default: `var(--future-background-default, ${palette.white})`,
  groupedPrimary: `var(--future-background-grouped-primary, ${palette.silicon00})`,
  groupedSecondary: `var(--future-background-grouped-secondary, ${palette.silicon05})`,
  success: `var(--future-background-success, ${palette.mint05})`,
  warning: `var(--future-background-warning, ${palette.turmeric05})`,
  error: `var(--future-background-error, ${palette.salmon00})`,
  highlight: `var(--future-background-highlight, ${palette.lilac00})`,
  info: `var(--future-background-info, ${palette.magnetic05})`,
  inverted: `var(--future-background-inverted, ${palette.magnetic80})`,
  placeholder: `var(--future-background-placeholder, ${palette.silicon25})`,
} as const

const divider = {
  default: `var(--future-divider-default, ${palette.silicon15})`,
  success: `var(--future-divider-success, ${palette.mint50})`,
  warning: `var(--future-divider-warning, ${palette.turmeric50})`,
  error: `var(--future-divider-error, ${palette.salmon40})`,
  focus: `var(--future-divider-focus, ${palette.lilac65})`,
  action: `var(--future-divider-action, ${palette.lilac65})`,
  info: `var(--future-divider-info, ${palette.magnetic50})`,
} as const

const icon = {
  default: `var(--future-icon-default, ${palette.silicon95})`,
  secondary: `var(--future-icon-secondary, ${palette.silicon60})`,
  action: `var(--future-icon-action, ${palette.lilac70})`,
  disabled: `var(--future-icon-disabled, ${palette.silicon40})`,
  highlight: `var(--future-icon-highlight, ${palette.lilac70})`,
  info: `var(--future-icon-info, ${palette.magnetic70})`,
  inverted: `var(--future-icon-inverted, ${palette.white})`,
  success: {
    large: `var(--future-icon-success-large, ${palette.mint50})`,
    small: `var(--future-icon-success-small, ${palette.mint70})`,
  },
  warning: {
    large: `var(--future-icon-warning-large, ${palette.turmeric50})`,
    small: `var(--future-icon-warning-small, ${palette.turmeric70})`,
  },
  error: {
    large: `var(--future-icon-error-large, ${palette.salmon40})`,
    small: `var(--future-icon-error-small, ${palette.salmon70})`,
  },
} as const

const action = {
  primary: {
    text: {
      default: `var(--future-action-primary-text-default, ${palette.white})`,
      hover: `var(--future-action-primary-text-hover, ${palette.white})`,
      selected: `var(--future-action-primary-text-selected, ${palette.white})`,
      disabled: `var(--future-action-primary-text-disabled, ${palette.white})`,
    },
    background: {
      default: `var(--future-action-primary-background-default, ${palette.lilac65})`,
      hover: `var(--future-action-primary-background-hover, ${palette.lilac70})`,
      selected: `var(--future-action-primary-background-selected, ${palette.lilac80})`,
      disabled: `var(--future-action-primary-background-disabled, ${palette.silicon30})`,
    },
    border: {
      default: `var(--future-action-primary-border-default, ${palette.lilac65})`,
      hover: `var(--future-action-primary-border-hover, ${palette.lilac70})`,
      selected: `var(--future-action-primary-border-selected, ${palette.lilac80})`,
      disabled: `var(--future-action-primary-border-disabled, ${palette.silicon30})`,
    },
  },
  secondary: {
    text: {
      default: `var(--future-action-secondary-text-default, ${palette.lilac80})`,
      hover: `var(--future-action-secondary-text-hover, ${palette.lilac80})`,
      selected: `var(--future-action-secondary-text-selected, ${palette.lilac80})`,
      disabled: `var(--future-action-secondary-text-disabled, ${palette.silicon40})`,
    },
    background: {
      default: `var(--future-action-secondary-background-default, ${palette.lilac10})`,
      hover: `var(--future-action-secondary-background-hover, ${palette.lilac20})`,
      selected: `var(--future-action-secondary-background-selected, ${palette.lilac30})`,
      disabled: `var(--future-action-secondary-background-disabled, ${palette.silicon05})`,
    },
    border: {
      default: `var(--future-action-secondary-border-default, ${palette.lilac20})`,
      hover: `var(--future-action-secondary-border-hover, ${palette.lilac30})`,
      selected: `var(--future-action-secondary-border-selected, ${palette.lilac40})`,
      disabled: `var(--future-action-secondary-border-disabled, ${palette.silicon10})`,
    },
  },
  destructive: {
    text: {
      default: `var(--future-action-destructive-text-default, ${palette.salmon90})`,
      hover: `var(--future-action-destructive-text-hover, ${palette.salmon90})`,
      selected: `var(--future-action-destructive-text-selected, ${palette.salmon90})`,
      disabled: `var(--future-action-destructive-text-disabled, ${palette.silicon40})`,
    },
    background: {
      default: `var(--future-action-destructive-background-default, ${palette.salmon05})`,
      hover: `var(--future-action-destructive-background-hover, ${palette.salmon10})`,
      selected: `var(--future-action-destructive-background-selected, ${palette.salmon20})`,
      disabled: `var(--future-action-destructive-background-disabled, ${palette.silicon05})`,
    },
    border: {
      default: `var(--future-action-destructive-border-default, ${palette.salmon10})`,
      hover: `var(--future-action-destructive-border-hover, ${palette.salmon20})`,
      selected: `var(--future-action-destructive-border-selected, ${palette.salmon30})`,
      disabled: `var(--future-action-destructive-border-disabled, ${palette.silicon10})`,
    },
  },
  minor: {
    text: {
      default: `var(--future-action-minor-text-default, ${palette.silicon95})`,
      hover: `var(--future-action-minor-text-hover, ${palette.silicon95})`,
      selected: `var(--future-action-minor-text-selected, ${palette.silicon95})`,
      disabled: `var(--future-action-minor-text-disabled, ${palette.silicon40})`,
    },
    background: {
      default: `var(--future-action-minor-background-default, ${palette.clear})`,
      hover: `var(--future-action-minor-background-hover, ${palette.silicon15})`,
      selected: `var(--future-action-minor-background-selected, ${palette.silicon30})`,
      disabled: `var(--future-action-minor-background-disabled, ${palette.clear})`,
    },
    border: {
      default: `var(--future-action-minor-border-default, ${palette.silicon15})`,
      hover: `var(--future-action-minor-border-hover, ${palette.silicon30})`,
      selected: `var(--future-action-minor-border-selected, ${palette.silicon30})`,
      disabled: `var(--future-action-minor-border-disabled, ${palette.silicon15})`,
    },
  },
  inline: {
    text: {
      default: `var(--future-action-inline-text-default, ${palette.lilac70})`,
      hover: `var(--future-action-inline-text-hover, ${palette.lilac50})`,
      selected: `var(--future-action-inline-text-selected, ${palette.lilac40})`,
      disabled: `var(--future-action-inline-text-disabled, ${palette.silicon40})`,
    },
    background: {
      default: `var(--future-action-inline-background-default, ${palette.clear})`,
      hover: `var(--future-action-inline-background-hover, ${palette.clear})`,
      selected: `var(--future-action-inline-background-selected, ${palette.clear})`,
      disabled: `var(--future-action-inline-background-disabled, ${palette.clear})`,
    },
    border: {
      default: `var(--future-action-inline-border-default, ${palette.clear})`,
      hover: `var(--future-action-inline-border-hover, ${palette.clear})`,
      selected: `var(--future-action-inline-border-selected, ${palette.clear})`,
      disabled: `var(--future-action-inline-border-disabled, ${palette.clear})`,
    },
  },
  inlineDestructive: {
    text: {
      default: `var(--future-action-inline-destructive-text-default, ${palette.salmon80})`,
      hover: `var(--future-action-inline-destructive-text-hover, ${palette.salmon60})`,
      selected: `var(--future-action-inline-destructive-text-selected, ${palette.salmon40})`,
      disabled: `var(--future-action-inline-destructive-text-disabled, ${palette.silicon40})`,
    },
    background: {
      default: `var(--future-action-inline-destructive-background-default, ${palette.clear})`,
      hover: `var(--future-action-inline-destructive-background-hover, ${palette.clear})`,
      selected: `var(--future-action-inline-destructive-background-selected, ${palette.clear})`,
      disabled: `var(--future-action-inline-destructive-background-disabled, ${palette.clear})`,
    },
    border: {
      default: `var(--future-action-inline-destructive-border-default, ${palette.clear})`,
      hover: `var(--future-action-inline-destructive-border-hover, ${palette.clear})`,
      selected: `var(--future-action-inline-destructive-border-selected, ${palette.clear})`,
      disabled: `var(--future-action-inline-destructive-border-disabled, ${palette.clear})`,
    },
  },
} as const

/**
 * @deprecated
 *
 * Please use the `colors` or `colorsRaw` tokens instead, they have the exact
 * same values are `futureColors` and `futureColorsRaw` respectively.
 */
export const futureColors = {
  text,
  background,
  divider,
  icon,
  action,
} as const
